// extracted by mini-css-extract-plugin
module.exports = {"title":"TopCategoriesSection_title__fb_VK","container":"TopCategoriesSection_container__KtLjs","wrapper":"TopCategoriesSection_wrapper__x59Be"};